import { Typography } from '@euler/app/components/typography';
import { canManageApdmImports } from '@euler/functions/apdmAccess';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { useUserProfileInfo } from '@euler/functions/user/useUserProfileInfo';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import { useNavigation } from '@react-navigation/native';
import { useEffect } from 'react';
import { View } from 'react-native';
import { useTheme } from 'styled-components';
import { ImportWorkspace } from './components/import-workspace';

export const ApdmImportPage = wrapNavigatorScreen(
  (props: { importId?: string }) => {
    const profile = useUserProfileInfo();
    const theme = useTheme();
    const { rpx } = useResponsiveContext();
    const navigation = useNavigation();
    useEffect(() => {
      navigation.setOptions({ title: '服务历史导入' });
    }, [navigation]);
    if (!canManageApdmImports(profile ?? null))
      return (
        <View
          style={{
            padding: rpx(24),
            backgroundColor: theme.page.background,
            flex: 1,
          }}
        >
          <Typography.Text color={theme.label.color}>
            当前账号没有服务历史导入权限，或门店尚未启用此服务。
          </Typography.Text>
        </View>
      );
    return (
      <ImportWorkspace
        key={`${profile!.user.userId}:${profile!.store.id}`}
        importId={props.importId ?? null}
      />
    );
  },
);
